module.exports = (parcelRequire.load("83zO9")).then(() => parcelRequire('01xS4'));